import { Box, Image, Loader } from '@mantine/core';

export const MainLoader = () => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '85vh',
      }}
    >
      <Image src="/logo.png" loading="lazy" alt="Loading..." w={350} />
      <Loader size={80} mt={40} />
    </Box>
  );
};
